'use strict';

angular.module('adelementAdminApp')
    .factory('ExcludedField', function ($resource, DateUtils) {
        return $resource('api/excludedFields/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
